<template>
    <div class="display-block">
        <data-table
            :rows="rows"
            :columns="columns"
            :page-size="pageSize"
            :page-size-options="pageSizeOptions"
            :classes="classes"
            :labels="labels"
            sort-prop="sort"
            :show-pager="!IS_MOBILE"
            :show-toolbar="!IS_MOBILE"
            filter-prop="value"
            :sort-functions="sortFunctions" />
        <div
            v-if="showMoreButton"
            class="statTable__expand padding-bottom-5">
            <button
                type="button"
                class="statTable__expandButton"
                data-gtm="statistic__showMoreData"
                @click="expandRows">
                {{ trans('STATISTIC_SHOW_MORE_DATA') }}
            </button>
        </div>
    </div>
</template>

<script>
    import DataTable from 'components/dataTable/dataTable';
    import { getTableColumns, getTableRows } from 'tools/tableUtils';
    import getSortNumberFn from 'components/dataTable/sortNumberConvert';
    import { isMobile } from 'tools/isMobile';
    import Translator from 'tools/trans';

    const STATISTIC_TABLE_ELEMENT = document.querySelector('#statTableHTML');
    const THOUSAND_SEPARATOR = Translator.trans('SEP_THOUSAND');
    const DIGIT_SEPARATOR = THOUSAND_SEPARATOR === ',' ? '.' : ',';
    const MOBILE_PAGE_SIZE_STEP = 5;

    export default {
        components: {
            DataTable,
        },
        data() {
            return {
                IS_MOBILE: isMobile(),
                columns: getTableColumns(STATISTIC_TABLE_ELEMENT),
                rows: getTableRows(STATISTIC_TABLE_ELEMENT).map((row, rowIndex) => {
                    return row.map((td, colIndex) => {
                        td.sort = colIndex === 0 ? rowIndex : td.value;

                        return td;
                    });
                }),
                sortFunctions: {
                    default: getSortNumberFn(THOUSAND_SEPARATOR, DIGIT_SEPARATOR),
                },
                classes: {
                    table: 'dataTable',
                    toolbar: 'dataTable__header',
                    footer: 'dataTable__footer',
                    pagePrev: 'text--link',
                    pageNext: 'text--link',
                    sort: 'sorting',
                    sortAsc: 'sorting_asc',
                    sortDesc: 'sorting_desc',
                },
                labels: {
                    searchLabel: `${ Translator.trans('SEARCH') }:`,
                    pageRangeLabel: Translator.trans('STATISTIC_TABLE_ENTRIES'),
                    pageSizeLabel: `${ Translator.trans('STATISTIC_TABLE_RECORDS') }: `,
                    pagePrev: Translator.trans('STATISTIC_TABLE_PREVIOUS'),
                    pageNext: Translator.trans('STATISTIC_TABLE_NEXT'),
                },
                pageSize: this.IS_MOBILE ? 26 : 13,
                pageSizeOptions: this.IS_MOBILE ? [26, 50, 100] : [13, 25, 50],
            };
        },
        computed: {
            showMoreButton() {
                return this.IS_MOBILE && this.rows.length > this.pageSize;
            },
        },
        methods: {
            trans: Translator.trans,
            expandRows() {
                this.pageSize += MOBILE_PAGE_SIZE_STEP;
            },
        },
        mounted() {
            STATISTIC_TABLE_ELEMENT.remove();
        },
    };
</script>
